<span
  class="d-inline-block svg-icon svg-icon-2x svg-icon-danger cursor-pointer"
  [inlineSVG]="ICON_ERROR"
></span>
